import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './theme.css';
import './styles.css';

declare const Office: any;

function mount() {
  const root = createRoot(document.getElementById('root')!);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

// Inside Outlook, wait for Office to be ready; on the standalone web page,
// Office.onReady resolves immediately (or Office is undefined → mount directly).
if (typeof Office !== 'undefined' && Office.onReady) {
  Office.onReady(() => mount());
} else {
  mount();
}
